<template>
  <PopUp
    v-if="isProToPremiumPopupVisible"
    :max-height="90"
    close-button
    close-button-variant="black"
    @close="closeProToPremiumPopup"
  >
    <div class="upgrade-popup">
      <div class="upgrade-popup__image pro-to-premium"></div>
      <div class="upgrade-popup__main-block">
        <div class="upgrade-popup__title">Upgrade to unlock this feature and many more amazing
          others
        </div>
        <ul class="upgrade-popup__items">
          <li
            class="upgrade-popup__item"
            v-for="(benefit,index) in upgradeBenefits"
            :key="index"
          >
            <img
              class="item__icon"
              :src="benefit.icon"
              :alt="benefit.alt"
            >
            <div class="item__text">{{ benefit.text }}</div>
          </li>
        </ul>
        <a
          @click="goToPricingPage"
          class="button-brand upgrade-popup__button"
        >Learn more
        </a>
        <div
          role="button"
          class="upgrade-popup__text"
          @click="closeProToPremiumPopup"
        >No thanks, maybe later
        </div>
      </div>
    </div>
  </PopUp>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import PopUp from '@/components/PopUp';

export default {
  name: 'ProToPremiumPopup',
  components: { PopUp },
  computed: {
    ...mapGetters({
      isProToPremiumPopupVisible: 'isProToPremiumPopupVisible',
    }),
    upgradeBenefits() {
      return [
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/business-school.svg'),
          text: 'Creator Business School courses',
          alt: 'School icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/consultant.svg'),
          text: '1-1 onboarding call',
          alt: 'Consultant icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/access.svg'),
          text: '100GB storage space',
          alt: 'Upload icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/fees.svg'),
          text: '0% transaction fees',
          alt: 'Fees icon',
        },
      ];
    },
  },
  methods: {
    ...mapMutations({
      closeProToPremiumPopup: 'closeProToPremiumPopup',
    }),
    goToPricingPage() {
      this.closeProToPremiumPopup();
      this.$router.push({ name: 'Pricing' });
    },
  },
};
</script>
